import { Controller } from 'stimulus';

export default class extends Controller {
  static values = {
    url: String,
    eventId: String,
  };

  async prepare() {
    const payMethods = document.querySelector(
      '[data-name="Pay Methods"].form-step__selector',
    );
    if (!payMethods || payMethods.dataset.skip !== 'true') return;

    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    await fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-CSRF-Token': token,
      },
      body: JSON.stringify({ event_id: this.eventIdValue }),
    });
  }
}
